import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import { addModelLog } from '@libs/NwLogs';

import { useStateValue } from '@contexts/StateProvider';
import { useUserPermission } from '@contexts/UserContext';

import { useContact } from '@hooks/API/Contact/UseContact';
import { useContactBillingInfos } from '@hooks/API/Contact/UseContactBillingInfos';
// import { getContactName } from '@hooks/API/Contact/UseContactsList';
import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import ContactDetailsActions from '@components/ContactDetails/ContactDetailsHeader/ContactDetailsActions';
import ObjectHistory from '@components/CreatedBy/ObjectHistory';
import FlexContainer from '@components/Gui/FlexContainer';
import { Loading } from '@components/Gui/Loading';
import NwDrawer from '@components/Gui/NwDrawer';
// import NwIcon from '@components/Gui/NwIcon';
import SystemMessage from '@components/Utils/SystemMessage';

import ModelDetailsAccountingContent from '../ModelDetailsAccountingContent';

// import ModelDetailsIndexMobile from '../ModelDetailsIndexMobile';
// import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Actions = styled(FlexContainer)`
    gap: 2rem;
    margin-right: 1rem;
`;

const ModelDrawerAccounting = ({ modelID, onClose, zIndex }) => {
    const loading = false;
    const { data: currentModel } = useContact(modelID);
    const { data: billingInfos } = useContactBillingInfos(modelID);

    const [{ areaContext }] = useStateValue();

    const accessAccounting = useUserPermission('AccessAccounting');

    const [isOpenHistory, setIsOpenHistory] = useState(false);

    const breakpoints = useNwBreakPoints();
    const isMobile = breakpoints === 1;

    useEffect(() => {
        if (currentModel) {
            addModelLog(currentModel, areaContext.area);
        }
    }, [currentModel]);

    if (!accessAccounting) {
        return (
            <NwDrawer width={400} onClose={onClose} whiteBg padding="0" zIndex={zIndex}>
                <SystemMessage type="not-allowed" />
            </NwDrawer>
        );
    }

    // if (isMobile) {
    //     return (
    //         <NwDrawer width="90vw" onClose={onClose} whiteBg padding="0" title={getContactName(modelID)}>
    //             {currentModel ? (
    //                 <ModelDetailsIndexMobile isDrawer modelId={modelID} currentContact={currentModel} />
    //             ) : (
    //                 <Loading />
    //             )}
    //         </NwDrawer>
    //     );
    // } else {
    return (
        <NwDrawer
            width="90vw"
            title={
                currentModel ? (
                    <FlexContainer justifyContent="space-between">
                        <div>Model (Accounting Details)</div>
                        <Actions>
                            {/* <NwIcon
                                    icon={byPrefixAndName.fasl['history']}
                                    size="lg"
                                    disabled
                                    pointer
                                    onClick={() => {}} //handleOpenHistory
                                /> */}
                            <ObjectHistory iconOnly onIconClick={() => {}} object={currentModel} />
                            <ContactDetailsActions contact={currentModel} fromDrawer onClose={onClose} />
                        </Actions>
                    </FlexContainer>
                ) : (
                    'Model Preview'
                )
            }
            onClose={onClose}
            whiteBg={false}
            zIndex={zIndex}
        >
            <div className="drawer-content">
                {loading || !currentModel ? (
                    <Loading />
                ) : (
                    <ModelDetailsAccountingContent currentModel={currentModel} billingInfos={billingInfos} />
                )}
            </div>
        </NwDrawer>
    );
    // }
};

export default ModelDrawerAccounting;
